export default __webpack_public_path__ + "Mask-group-21.44c74d.svg";